"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const abstract_filter_item_1 = require("./abstract-filter-item");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const date_filter_picker_types_1 = require("./date-filter-picker-types");
const date_filter_default_value_types_1 = require("./date-filter-default-value-types");
class CategoryDayFilterItem extends abstract_filter_item_1.AbstractFilterItem {
    constructor(id, label, onValueChange, defaultValues = null) {
        super(id, label, onValueChange);
        this.defaultValues = defaultValues;
        if (defaultValues) {
            this._valueTo = defaultValues.valueTo ? new Date(defaultValues.valueTo) : null;
            this._valueFrom = defaultValues.valueFrom ? new Date(defaultValues.valueFrom) : null;
            this._type = defaultValues.type !== undefined && defaultValues.type !== null ? defaultValues.type : date_filter_picker_types_1.DateFilterPickerTypes.RANGE;
            this._dateType = defaultValues.dateType !== undefined && defaultValues.dateType !== null ? defaultValues.dateType : date_filter_default_value_types_1.DateFilterDefaultValueTypes.CUSTOM;
            if (this._type === date_filter_picker_types_1.DateFilterPickerTypes.DATE &&
                this._dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.CUSTOM &&
                this._dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_AFTER &&
                this._dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_BEFORE) {
                this._valueFrom = new Date();
                switch (this._dateType) {
                    case date_filter_default_value_types_1.DateFilterDefaultValueTypes.PREVIOUS:
                        this._valueFrom.setUTCDate(this._valueFrom.getUTCDate() - 1);
                        break;
                    case date_filter_default_value_types_1.DateFilterDefaultValueTypes.NEXT:
                        this._valueFrom.setUTCDate(this._valueFrom.getUTCDate() + 1);
                        break;
                }
            }
        }
        else {
            this._valueTo = null;
            this._valueFrom = null;
            this._type = date_filter_picker_types_1.DateFilterPickerTypes.RANGE;
            this._dateType = date_filter_default_value_types_1.DateFilterDefaultValueTypes.CUSTOM;
        }
    }
    get valueFrom() {
        return this._valueFrom;
    }
    set valueFrom(value) {
        this._valueFrom = value;
        this.validate() && this.onFilterItemChange();
    }
    get valueTo() {
        return this._valueTo;
    }
    set valueTo(value) {
        this._valueTo = value;
        this.validate() && this.onFilterItemChange();
    }
    set dateType(value) {
        this._dateType = value;
        if (this._type === date_filter_picker_types_1.DateFilterPickerTypes.DATE &&
            this._dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.CUSTOM &&
            this._dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_AFTER &&
            this._dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_BEFORE) {
            this._valueFrom = new Date();
            switch (this._dateType) {
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.PREVIOUS:
                    this._valueFrom.setUTCDate(this._valueFrom.getUTCDate() - 1);
                    break;
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.NEXT:
                    this._valueFrom.setUTCDate(this._valueFrom.getUTCDate() + 1);
                    break;
            }
        }
        else {
            this._valueFrom = null;
        }
        this._valueTo = null;
        this.validate() && this.onFilterItemChange();
    }
    get dateType() {
        return this._dateType;
    }
    setDateType(value) {
        this._dateType = value;
    }
    set type(value) {
        this._type = value;
        if (value === date_filter_picker_types_1.DateFilterPickerTypes.DATE) {
            this.dateType = date_filter_default_value_types_1.DateFilterDefaultValueTypes.CURRENT;
        }
        else {
            this.dateType = date_filter_default_value_types_1.DateFilterDefaultValueTypes.CUSTOM;
        }
        this.validate() && this.onFilterItemChange();
    }
    get type() {
        return this._type;
    }
    validate() {
        let isValid = true;
        if (this._type === date_filter_picker_types_1.DateFilterPickerTypes.RANGE) {
            isValid = this.valueFrom != null && this.valueTo != null
                && this.valueFrom.getTime() <= this.valueTo.getTime()
                || (this.valueFrom == null || this.valueTo == null);
        }
        isValid ? this.validationMessage = '' : this.validationMessage = this.DATE_RANGE_VALIDATION_MESSAGE;
        return isValid;
    }
    getFilterTreeDto() {
        const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
        if (this._type === date_filter_picker_types_1.DateFilterPickerTypes.DATE) {
            if (this.valueFrom === null) {
                return null;
            }
            switch (this._dateType) {
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.PREVIOUS:
                    filterBuilder.filterByCategory(this.id).isLast(1);
                    return filterBuilder.build();
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.CURRENT:
                    filterBuilder.filterByCategory(this.id).isCurrent();
                    return filterBuilder.build();
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.NEXT:
                    filterBuilder.filterByCategory(this.id).isNext(1);
                    return filterBuilder.build();
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_AFTER:
                    filterBuilder.filterByCategory(this.id).onOrAfter(this.valueFrom);
                    return filterBuilder.build();
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_BEFORE:
                    filterBuilder.filterByCategory(this.id).onOrBefore(this.valueFrom);
                    return filterBuilder.build();
                case date_filter_default_value_types_1.DateFilterDefaultValueTypes.CUSTOM:
                    filterBuilder.filterByCategory(this.id).is(this.valueFrom);
                    return filterBuilder.build();
                default:
                    throw new Error("Invalid date type `" + this._dateType + "'");
            }
        }
        else {
            if (this.valueFrom == null && this.valueTo == null) {
                return null;
            }
            if (this.valueFrom != null && this.valueTo != null) {
                filterBuilder.filterByCategory(this.id).between(this.valueFrom, this.valueTo);
                return filterBuilder.build();
            }
            else if (this.valueFrom != null) {
                filterBuilder.filterByCategory(this.id).onOrAfter(this.valueFrom);
                return filterBuilder.build();
            }
            else if (this.valueTo != null) {
                filterBuilder.filterByCategory(this.id).onOrBefore(this.valueTo);
                return filterBuilder.build();
            }
        }
    }
    getDefaultValue() {
        return {
            valueFrom: this._valueFrom,
            valueTo: this._valueTo,
            dateType: this._dateType,
            type: this._type
        };
    }
}
exports.CategoryDayFilterItem = CategoryDayFilterItem;
//# sourceMappingURL=category-day-filter-item.js.map